"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const styled_1 = require("./styled");
const react_1 = __importDefault(require("react"));
const Card = ({ category, description, createdAt, action, title }) => {
    return (react_1.default.createElement(styled_1.StyledCardWrapper, null,
        react_1.default.createElement(styled_1.CategoryWrapper, null,
            category,
            " "),
        react_1.default.createElement(styled_1.StyledBlock, null,
            action ? (react_1.default.createElement(styled_1.TitleLinkWrapper, { title: action.title, to: action.url })) : (react_1.default.createElement(styled_1.TitleWrapper, null,
                " ",
                title,
                " ")),
            react_1.default.createElement(styled_1.DescriptionWrapper, null,
                " ",
                description,
                " ")),
        react_1.default.createElement(styled_1.DateWrapper, null,
            " ",
            createdAt,
            " ")));
};
exports.Card = Card;
